import { useEffect, useMemo, useState } from "react";

import { useGetPetYardWeather } from "@/hooks/queries/useGetPetYardWeather";
import { MS_PER_MINUTE } from "@/lib/constants";
import { playyardSky } from "@/lib/playyardSky";
import { PlayyardSkyPreview } from "@/types";

// The sky only needs to move once a minute; palettes blend over ~an hour.
export const usePlayyardSky = ({
  isOpen,
  preview,
}: {
  isOpen: boolean;
  preview: PlayyardSkyPreview;
}) => {
  const { data: weather } = useGetPetYardWeather({ isEnabled: isOpen });
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!isOpen) return;

    const tick = () => {
      setNow(Date.now());
    };
    // Catch up immediately after the yard was closed for a while.
    const catchUpId = setTimeout(tick, 0);
    const intervalId = setInterval(tick, MS_PER_MINUTE);
    return () => {
      clearTimeout(catchUpId);
      clearInterval(intervalId);
    };
  }, [isOpen]);

  const sky = useMemo(
    () => playyardSky.compute({ now, weather, preview }),
    [now, preview, weather],
  );

  return { sky, weather: weather ?? null, now };
};
